module.exports = __webpack_public_path__ + "static/media/runza-logo-tagline.b8811a9e.png";